export enum PaymentInfoStatus {
  PendingApproval = "PendingApproval",
  Approved = "Approved",
  Rejected = "Rejected",
  Deleted = "Deleted",
}
